import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import chapterActions from "app/utils/chapterActions";
import alertActions from "app/utils/alertActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import { Feather, FontAwesome } from "@expo/vector-icons";

import Icon from "app/components/Icon";
import Hoverable from "app/components/Hoverable";
import Draggable from "app/components/Draggable";
import Badge from "app/components/chapter/Badge";
import MomentBullet from "app/components/chapter/MomentBullet";
import EventEditor from "app/components/chapter/EventEditor";
import ValueListItem from "app/components/ValueListItem";
import HoverableTooltip from "app/components/HoverableTooltip";
import Tag from "app/components/chapter/Tag";

export default class TimelineRow extends React.Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    // button: Component
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      chapter: props.chapter,
      expanded: props.expanded || false,
      selectedMoment: null,
      showMore: false,
    };
  }

  componentDidMount = () => {
    // this.generateSlots()
  };

  generateSlots = async () => {
    let { moment } = this.props;
    let value = moment.value;
    let recursive = false;

    let events = valueHelpers.getTimeline(value, recursive);
    if (allRevisions) {
      let revisions = valueHelpers.getRevisions(value);
      for (let r of revisions) {
        events = [...events, ...valueHelpers.getTimeline(r, recursive)];
      }
    }
    events = textHelpers.uniq(events, "event_id");
    events = textHelpers.oldestFirst(events, "timestamp");
    // events = events.reverse();
    console.log("timeline events:", events);

    let { slots, startAt, endAt, range, averageSpan } =
      this.formatSlots(events);

    this.setState({
      events,
      startAt,
      endAt,
      range,
      slots,
      averageSpan,
      // key: key + 1,
    });
  };

  formatSlots = (events) => {
    let { value } = this.props;

    let startAt = value.created_at;
    if (!!events?.length) {
      let firstEvent = events[0];
      let eStartAt = firstEvent.timestamp;
      if (!startAt || eStartAt < startAt) startAt = eStartAt;
      // startAt = timeHelpers.beginningOfMonth(startAt);
    }
    startAt = timeHelpers.dateTimeToDate(startAt);

    let endAt = value.completed_at || new Date();
    if (!!events?.length) {
      let lastEvent = events[0];
      let eEndAt = lastEvent.timestamp;
      if (!endAt || eEndAt > endAt) endAt = eEndAt;
    }
    endAt = timeHelpers.dateTimeToDate(endAt);

    let range = Math.ceil(timeHelpers.daysAgo(startAt, endAt));

    if (range < 6) {
      let diff = 6 - range;
      let startAtDiff = Math.floor(diff / 2);
      let endAtDiff = Math.ceil(diff / 2);
      startAt = timeHelpers.tomorrow(startAt, -startAtDiff);
      startAt = timeHelpers.dateTimeToDate(startAt);
      endAt = timeHelpers.tomorrow(endAt, -endAtDiff);
      endAt = timeHelpers.dateTimeToDate(endAt);
      range = 6;
    }

    let gaps = [];
    let lastEventDay = null;

    let slots = [];

    let minCushionDays = 4;
    let badgeWidth = this.context.sizes.base * 1.2;
    let slotWidth = this.context.sizes.WIDTH / range;
    if (slotWidth < badgeWidth) {
      minCushionDays *= Math.ceil(badgeWidth / slotWidth);
    }

    let cushionDays = Math.min(minCushionDays, Math.floor(range / 7)); // 1 day for each 1 week

    let start = 0 - cushionDays;
    let end = range + cushionDays;
    for (let i = start; i <= end; i++) {
      let slotDate = timeHelpers.tomorrow(startAt, i);
      slotDate = timeHelpers.dateTimeToDate(slotDate);
      let dateEvents = events.filter((ev) => {
        // let evTs = ev.completed_at || ev.created_at;
        let evTs = ev.timestamp;
        let evDate = timeHelpers.dateTimeToDate(evTs);
        if (evDate == slotDate) {
          return true;
        } else {
          return false;
        }
      });
      if (!!dateEvents.length) {
        if (!!lastEventDay) {
          gaps.push(timeHelpers.daysApart(slotDate, lastEventDay));
        }
        lastEventDay = slotDate;
      }
      slots.push({
        date: slotDate,
        events: dateEvents,
        cushion: i < 0 || i > range,
      });
    }
    // slots = slots.reverse(); // reverse if using the inverted FlatList
    // console.log("SLOTS", slots, events.length);
    let averageSpan = !gaps.length
      ? "n/a"
      : gaps.reduce((a, b) => a + b) / gaps.length;

    return { events, slots, startAt, endAt, range, averageSpan };
  };

  async componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    let {
      moments,
      loading,
      title,
      button,
      maxLength,
      firstButton,
      onPressTitle,
      onDoublePressTitle,
    } = this.props;
    let { selectedMoment, showMore } = this.state;

    let overflowing = !showMore && !!maxLength && moments?.length > maxLength;
    let overflowingBy = !!overflowing ? moments.length - maxLength : 0;

    // console.log(values);

    const scrollable = !ENV.WEB || this.props.tags;
    const MaybeScrollView = scrollable ? ScrollView : View;

    if (!moments?.length && loading) {
      return null;
    }
    if (!!moments?.length || !!firstButton || !!onPressTitle) {
      return (
        <MaybeScrollView horizontal style={{ flexDirection: "row" }}>
          {moments?.map((moment, i) => {
            if (showMore || !maxLength || i < maxLength)
              return this.renderNode(moment, i);
          })}
        </MaybeScrollView>
      );
      return (
        <View
          style={[styles.topMargin, styles.wrapper, this.props.wrapperStyle]}
        >
          <MaybeScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={{
              borderWidth: 1,
              overflow: "visible",
              // flexGrow: 0,
              // width: "100%",
            }}
            contentContainerStyle={
              {
                // alignSelf: "stretch",
              }
            }
          >
            <View
              horizontal
              showsHorizontalScrollIndicator={false}
              style={[
                styles.row,
                {
                  flexGrow: 0,
                  zIndex: 2,
                },
              ]}
              contentContainerStyle={{
                ...styles.row,
              }}
            >
              {!!title && (
                <HoverableTooltip
                  text={this.props.titleTooltip}
                  rightAligned={false}
                >
                  <TouchableOpacity
                    onPress={onPressTitle}
                    onDoubblePress={onDoublePressTitle}
                  >
                    {!!title?.length ? <Text>{title} </Text> : title}
                  </TouchableOpacity>
                </HoverableTooltip>
              )}

              {!!firstButton && firstButton()}

              {this.renderStartAt()}

              {moments?.map((moment, i) => {
                if (showMore || !maxLength || i < maxLength)
                  return this.renderNode(moment, i);
              })}

              {overflowing && !showMore && (
                <Text
                  style={{ ...styleSheet.bullet, width: "auto" }}
                  onPress={() => this.setState({ showMore: true })}
                >
                  +{overflowingBy}
                </Text>
              )}

              {button}
            </View>
          </MaybeScrollView>

          {!!selectedMoment &&
            (!!selectedMoment?.category ? (
              <EventEditor
                key={selectedMoment.timestamp}
                category={selectedMoment.category}
                timestamp={selectedMoment.timestamp}
                value={selectedMoment.value}
                onClose={() => {
                  this.setState({ selectedMoment: null });
                  // update chapter or something?
                }}
                composer={selectedMoment.composer}
              />
            ) : (
              <MomentBullet
                key={selectedMoment?.value.id}
                moment={selectedMoment}
                // value={item.value}
                chapter={this.props.chapter}
                rootChapter={this.props.rootChapter}
                chapterMoments={this.props.chapterMoments}
                onRefreshChapter={this.props.onRefreshChapter}
                onUpdateChapter={this.props.onUpdateChapter}
                expanded={this.props.autoExpandMoment}
                onUpdateChapter={this.props.onUpdateChapter}
                includeAttribution={this.props.includeAttribution}
              />
            ))}
        </View>
      );
    }
    return null;
  }

  renderNode = (moment, i) => {
    let { smallBadges, tags, doublePressActions } = this.props;
    let { selectedMoment } = this.state;
    if (!moment)
      console.log("missing moment?", this.props.chapter, this.props.moments);
    if (!moment) return null;
    let value = moment.value;

    let isSelected =
      !!selectedMoment?.value?.id && selectedMoment.value.id == moment.value.id;

    const Elem = tags ? Tag : Badge;

    return (
      <Hoverable
        key={i}
        // onHoverIn={() => {
        //  // this.handleHoverIn(uKey, nextGen.length);
        //  // this.props.hoverIn && this.props.hoverIn(value);
        // }}
        // onHoverOut={async () => {
        // // this.handleHoverOut(uKey, nextGen.length);
        // // this.props.hoverOut && this.props.hoverOut(value);
        // }}
      >
        {(isHovered) => {
          if (moment.category == "placeholder") isHovered = false;
          let badgeIsParentMomentsProgress = false;
          if (
            !!this.props.moment?.completed_at &&
            moment.category == "progress" &&
            textHelpers.formatDate(this.props.moment.completed_at) ==
              textHelpers.formatDate(value.timestamp)
          ) {
            badgeIsParentMomentsProgress = true;
          }
          return (
            <View
              key={i}
              style={[
                // i > 0 && { marginLeft: sizes.small },
                { marginRight: smallBadges ? sizes.tiny : sizes.small },
                isHovered && { zIndex: 1 },
                // { backgroundColor: "red" },
                // { maxHeight: 7, justifyContent: "center" },
              ]}
            >
              <Elem
                value={value}
                moment={moment}
                chapter={this.props.chapter}
                statusOverride={isSelected ? "completion" : undefined}
                highlighted={
                  badgeIsParentMomentsProgress ||
                  selectedMoment?.placeholderIndex == i ||
                  (!!selectedMoment?.category && isSelected)
                }
                onDoublePress={
                  !doublePressActions?.length
                    ? null
                    : async () => {
                        let subtitle = ENV.WEB
                          ? null
                          : value.title || value.text;
                        let res = await alertActions.confirm({
                          options: doublePressActions,
                          title: "Take Action",
                          subtitle,
                        });
                        this.handleActionRes(value, res, doublePressActions);
                      }
                }
                onPress={() => {
                  if (moment.category == "placeholder") {
                    if (
                      this.props.allowProgressOnPressPlaceholder &&
                      !selectedMoment
                    ) {
                      this.setState({
                        selectedMoment: {
                          placeholderIndex: i,
                          category: "composer",
                          timestamp: new Date(),
                          composer: true,
                          value: {
                            color: this.props.color,
                            valueId:
                              value.id || value.valueId || value.value_id,
                            timestamp: new Date(),
                          },
                        },
                      });
                      return;
                    }
                    this.setState({ selectedMoment: null });
                    return;
                  }
                  console.log(moment, value);
                  let isSelected =
                    !!selectedMoment?.id && selectedMoment.id == moment.id;
                  if (isSelected) {
                    this.setState({ selectedMoment: null });
                    console.log("clearing slection");
                  } else {
                    this.setState({ selectedMoment: moment });
                    console.log("selectin", moment);
                  }
                }}
                noTooltip={moment.category == "placeholder"}
                tooltipText={
                  moment.category == "progress"
                    ? textHelpers.fullDateTime(moment.timestamp)
                    : undefined
                }
                icon
              />
            </View>
          );
        }}
      </Hoverable>
    );
    //}}
    //</Draggable>
    //);
  };

  renderStartAt = () => {
    let { value, tags, smallBadges } = this.props;
    if (!value?.created_at) return null;
    let createdAt = `Created: ` + timeHelpers.dateTimeToDate(value.created_at);
    const Elem = tags ? Tag : Badge;
    return (
      <HoverableTooltip text={createdAt} rightAligned={false}>
        {(isHovered) => {
          return (
            <View
              style={[
                { marginRight: smallBadges ? sizes.tiny : sizes.small },
                isHovered && { zIndex: 1 },
              ]}
            >
              <Elem
                value={value}
                moment={{ value }}
                chapter={this.props.chapter}
                noTooltip={moment.category == "placeholder"}
                tooltipText={undefined}
                icon
              />
            </View>
          );
        }}
      </HoverableTooltip>
    );
    //}}
    //</Draggable>
    //);
  };

  handleActionRes = async (value, res, options) => {
    let { chapter } = this.props;
    let i = res - 1;
    let actionRes;
    if (options[i] == "Pin") {
      let actionRes = await chapterActions.pinValue(chapter.id, value.id);
    } else if (options[i] == "Dismiss") {
      actionRes = await chapterActions.dismissSuggestion(chapter, value.id);
    } else if (options[i] == "Snooze") {
      alert("Snooze for how long?");
    }
  };
}

const styles = StyleSheet.create({
  wrapper: {
    // paddingHorizontal: sizes.small,
    // backgroundColor: colors.fill,
    // borderRadius: sizes.smallBorderRadius,
    // alignItems: "stretch",
    flex: 1,
  },
  topMargin: {
    // marginTop: sizes.base,
  },
  row: {
    // padding: sizes.base,
    flexDirection: "row",
    flexWrap: "no-wrap",
    alignItems: "center",
    alignSelf: "stretch",
    // width: 400,
    // borderRadius: sizes.large,
    // overflow: "visible",
  },
});
